import { Schema } from "@effect/schema";
import { ProtocolKey } from "../protocol";

export const MarketsSortField = Schema.Literal(
  "marketSymbol",
  "liquidityUsd",
  "baseDepositTotalApr",
  "baseDebtTotalApr",
  "firstBridgeDepositTotalApr",
  "firstBridgeDebtTotalApr",
  "secondBridgeDepositTotalApr",
  "secondBridgeDebtTotalApr"
).annotations({
  identifier: "MarketsSortField",
});

export type MarketsSortField = typeof MarketsSortField.Type;
export const marketsSortFields = MarketsSortField.literals;
export const isMarketsSortField = Schema.is(MarketsSortField);

export const SortDirection = Schema.Literal("asc", "desc").annotations({
  identifier: "SortDirection",
});
export type SortDirection = typeof SortDirection.Type;
export const sortDirections = SortDirection.literals;
export const isSortDirection = Schema.is(SortDirection);

export type MarketsSort = typeof MarketsSort.Type;
export type MarketsSortEncoded = typeof MarketsSort.Encoded;

export const MarketsSort = Schema.NullOr(
  Schema.Struct({
    field: MarketsSortField,
    direction: SortDirection,
  })
).annotations({ identifier: "MarketsSort" });

export type MarketsOptions = typeof MarketsOptions.Type;
export type MarketsOptionsEncoded = typeof MarketsOptions.Encoded;

export const MarketsOptions = Schema.Struct({
  protocolKey: ProtocolKey,
  sort: MarketsSort,
  search: Schema.NullOr(Schema.String),
  pages: Schema.NullOr(Schema.Number),
}).annotations({ identifier: "MarketsOptions" });

export const MARKETS_PAGE_SIZE = 12;

export type SortBy = (
  field: MarketsSortField,
  direction?: "asc" | "desc"
) => void;
